import {
  CarriedInterestFeeAllocationMethod,
  WaterfallStructure,
} from 'further-types/lp/carry-settings';
import { carrySettings } from 'further-ui/validations';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';
import api from 'lib/trpcClient';
import { z } from 'zod';

export type FormValues = z.infer<
  typeof carrySettings.OverallCarriedInterestSettings
>;

const feeAllocationMethodOptions = [
  {
    label: 'Commitment pro-rata',
    value: CarriedInterestFeeAllocationMethod.CommitmentProRata,
  },
  {
    label: 'Investor-specific',
    value: CarriedInterestFeeAllocationMethod.InvestorSpecific,
  },
];
const defaultWaterfallStructure = [
  WaterfallStructure.ReturnOfCapital,
  WaterfallStructure.PreferredReturn,
  WaterfallStructure.CarriedInterestPartnerCatchup,
  WaterfallStructure.ExcessProceeds,
];

export default function useOverallCarriedInterestSettings() {
  const options = useHandleTrpcMutation()({
    successMessage: 'Overall carried interest settings updated',
  });

  const { mutate: updateSettings, isPending } =
    api.vehicle.updateOverallCarriedInterestSettings.useMutation(options);

  return {
    feeAllocationMethodOptions,
    defaultWaterfallStructure,
    updateSettings,
    isPending,
  };
}
